import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import _ from 'lodash';

import {
  fetchActivity,
  setActivity,
  setActivityForm,
  deleteActivity,
} from '../../../store/modules/activity';
import { deleteFile } from '../../../store/modules/file';
import Activity from '../components/Activity';

const mapActionCreators = {
  fetchActivity,
  setActivity,
  setActivityForm,
  deleteActivity,
  deleteFile,
  push,
};

const mapStateToProps = state => {
  let serviceKey = null;
  let serviceType = null;

  if (state.activity.activities[state.activity.current]) {
    if (
      typeof state.activity.activities[state.activity.current] !== 'undefined'
    ) {
      serviceType =
        state.serviceType.serviceTypes[
          state.activity.activities[state.activity.current].service_type_id
        ];
      if (typeof serviceType !== 'undefined') {
        serviceKey = state.serviceKey.serviceKeys[serviceType.service_key_id];
      }
    }
  }

  return {
    activity: state.activity.activities[state.activity.current],
    formOpen: state.activity.formOpen,
    activityCount: Object.keys(
      _.filter(state.activity.activities, o => o.deleted_at === null),
    ).length,
    company: state.activity.activities[state.activity.current]
      ? state.company.companies[
          state.activity.activities[state.activity.current].company_id
        ]
      : null,
    companies: _.filter(
      _.pick(
        state.company.companies,
        state.activity.activities[state.activity.current]
          ? state.activity.activities[state.activity.current].companies
          : null,
      ),
      ['deleted_at', null],
    ),
    project: state.activity.activities[state.activity.current]
      ? state.project.projects[
          state.activity.activities[state.activity.current].project_id
        ]
      : null,
    responsible: state.activity.activities[state.activity.current]
      ? state.staff.staffs[
          state.activity.activities[state.activity.current].responsible_user
        ]
      : null,
    files: _.filter(
      _.pick(
        state.file.files,
        state.activity.activities[state.activity.current]
          ? state.activity.activities[state.activity.current].files
          : null,
      ),
      ['deleted_at', null],
    ),
    tasks: _.filter(
      _.pick(
        state.task.tasks,
        state.activity.activities[state.activity.current]
          ? state.activity.activities[state.activity.current].tasks
          : null,
      ),
      ['deleted_at', null],
    ),
    persons: _.filter(
      _.pick(
        state.person.persons,
        state.activity.activities[state.activity.current]
          ? state.activity.activities[state.activity.current].persons
          : null,
      ),
      ['deleted_at', null],
    ),
    staffs: _.filter(
      _.pick(
        state.staff.staffs,
        state.activity.activities[state.activity.current]
          ? state.activity.activities[state.activity.current].staff
          : null,
      ),
      ['deleted_at', null],
    ),
    serviceType,
    serviceKey,
    fetching: state.activity.fetching,
  };
};

export default connect(mapStateToProps, mapActionCreators)(Activity);



// WEBPACK FOOTER //
// ./src/routes/ActivityDetail/containers/ActivityContainer.js